<template>
  <v-card>
    <v-card-text>
      <div id="dropin-container"></div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="''"
        color="accent"
        flat
      >
        Cancel
      </v-btn>
      <v-btn
        @click="dropinRequestPaymentMethod()"
        color="accent"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios';

const dropin = require('braintree-web-drop-in');

export default {
  props: {
    collectCardHolderName: {
      type: Boolean,
    },
    collectPostalCode: {
      type: Boolean,
    },
    enableDataCollector: {
      type: Boolean,
    },
    enablePaypal: {
      type: Boolean,
    },
  },
  data() {
    return {
      apiUrl: window.api_url,
      clientToken: null,
      errorMessage: '',
      dropinInstance: '',
      paymentPayload: '',
      dataCollectorPayload: '',
    };
  },
  mounted() {
    if (this.$store.getters.isSubscriptionUser && !this.$store.getters.isSubscribed) {
      const vm = this;

      axios.get(`${this.apiUrl}api/subscription/generate-client-token`)
        .then((response) => {
          this.clientToken = response.data;
          this.dropinCreate();
        }).catch((error) => {
          vm.$toasted.show(
            `There was an error creating subscription dialog. Message: ${error}`,
            { duration: 3000, singleton: true, type: 'error' },
          );
        });
    }
  },
  methods: {
    dropinCreate() {
      // setup drop-in options
      const dropinOptions = {
        authorization: this.clientToken,
        container: '#dropin-container',
      };
      const vm = this;

      // if PayPal enabled, add to options settings
      if (this.enablePayPal) {
        dropinOptions.paypal = {
          flow: 'vault',
        };
      }

      dropin.create(dropinOptions, (dropinError, dropinInstance) => {
        if (dropinError) {
          vm.$toasted.show(
            `There was an error setting up the client instance. Message: ${dropinError.message}`,
            { duration: 3000, singleton: true, type: 'error' },
          );
          return;
        }

        this.dropinInstance = dropinInstance;
      });
    },
    dropinRequestPaymentMethod() {
      const vm = this;

      this.dropinInstance.requestPaymentMethod((requestErr, payload) => {
        if (requestErr) {
          vm.$toasted.show(
            `There was an error setting up the client instance. Message: ${requestErr.message}`,
            { duration: 3000, singleton: true, type: 'error' },
          );
          return;
        }

        this.paymentPayload = payload;

        axios.post(`${this.apiUrl}api/subscription/subscribe`, {
          nonce: this.paymentPayload,
        }).then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        }).catch((error) => {
          vm.$toasted.show(
            `There was an error subscribing user. Message: ${error}`,
            { duration: 3000, singleton: true, type: 'error' },
          );
        });
      });
    },
  },
};
</script>

<style scoped>

</style>
